import clsx from 'clsx';
import { DataTestConfig } from '@headless-workspace/config';
import { InnerHTML } from '@headless-workspace/domain/common/client';
import { AsyncComponent, HTMLString, TileProductValue } from '@headless-workspace/domain/common/server';
import { GlowContainerSection, PropsWithClassName, PropsWithLocale } from '@headless-workspace/glow-ds';
import { CTA } from '../../types';
import { ProductCarouselContainer } from './ProductCarouselContainer';

type HomeProductCarouselSectionProps = PropsWithClassName &
    PropsWithLocale & {
        title: HTMLString;
        cta?: CTA;
        products: TileProductValue[];
        sectionType: string;
    };

export const HomeProductCarouselSection: AsyncComponent<HomeProductCarouselSectionProps> = async ({
    title,
    cta,
    products,
    className,
    locale,
    sectionType,
}) => {
    if (products.length === 0) {
        return null;
    }

    return (
        <GlowContainerSection
            className={clsx('gap-1.5 tablet:gap-2 desktop:px-1.5', className)}
            titleContainerClassName={'px-1 desktop:px-4'}
            title={<InnerHTML rawHtml={title} />}
            button={cta}
            titleClassName={'line-clamp-2'}
            dataTestId={`${DataTestConfig.testIds.homeSlotSection}${sectionType}`}
        >
            <ProductCarouselContainer products={products} locale={locale} />
        </GlowContainerSection>
    );
};
